import { useState } from "react";
import { useTranslation } from "react-i18next";
import { NeuButton, NeuCard, NeuInput } from "../../components/neu/Neu";

const MIN = 10;

// نافذة تجاوز السلّم التأديبي: زر الإرسال مقفل حتى يُكتب سبب لا يقل عن 10 أحرف.
export const OverrideDialog = ({ open, onCancel, onConfirm, level, current }) => {
  const { t } = useTranslation();
  const [reason, setReason] = useState("");
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/80 p-4"
         data-testid="penalty-override-dialog">
      <NeuCard className="grid w-full max-w-lg gap-4">
        <h3 className="text-lg font-black text-destructive">{t("penalty.override.title")}</h3>
        <p className="text-sm text-muted-foreground">
          {t("penalty.override.body", { current, level })}
        </p>
        <label className="grid gap-1 text-xs font-bold">
          {t("penalty.override.reason")}
          <NeuInput
            data-testid="penalty-override-reason-input"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder={t("penalty.override.placeholder")}
          />
        </label>
        <p className="text-[11px] text-muted-foreground num">
          {reason.trim().length}/{MIN}
        </p>
        <div className="flex flex-wrap gap-3">
          <NeuButton
            variant="primary"
            data-testid="penalty-override-submit"
            disabled={reason.trim().length < MIN}
            onClick={() => onConfirm(reason.trim())}
          >
            {t("penalty.override.submit")}
          </NeuButton>
          <NeuButton data-testid="penalty-override-cancel" onClick={onCancel}>
            {t("common.cancel")}
          </NeuButton>
        </div>
      </NeuCard>
    </div>
  );
};
